var $02c92e5e0c81f9a9$exports = {};
$02c92e5e0c81f9a9$exports = {
    "loading": `L\xe4ser in...`,
    "loadingMore": `L\xe4ser in mer...`
};


export {$02c92e5e0c81f9a9$exports as default};
//# sourceMappingURL=sv-SE.module.js.map
